export default __webpack_public_path__ + "static/media/BookGas.b8208adf.svg";